import { useCallback, useState } from 'react';
const focusableNodeTypes = ['input', 'select', 'textarea', 'button', 'a'];
const isFocusable = node => {
  if (node.getAttribute('tab-index') === '-1') {
    return false;
  }
  if (node.hasAttribute('disabled')) {
    return node.getAttribute('disabled') === 'false';
  }
  if (focusableNodeTypes.includes(node.nodeName.toLowerCase())) {
    return true;
  }
  return false;
};
const deepFindNode = (nodes, findFn) => {
  return nodes.some(node => {
    if (findFn(node)) {
      return true;
    }
    if (node.children.length === 0) {
      return false;
    }
    return deepFindNode(Array.from(node.children), findFn);
  });
};

/**
 * Supports interactive footers by keeping the menu open when we have selected items and we're tabbing into the footer.
 */
export default (_ref => {
  let {
    id
  } = _ref;
  const [keepMenuOpenOnBlur, setKeepMenuOpenOnBlur] = useState(false);
  const onKeyDown = useCallback(e => {
    if (e.key === 'Tab') {
      const footerElement = document.getElementById("".concat(id, "-dropdown-footer"));
      const childrenArray = footerElement !== null && footerElement !== void 0 && footerElement.children ? Array.from(footerElement.children) : [];
      const hasFocusableChild = deepFindNode(childrenArray, isFocusable);
      setKeepMenuOpenOnBlur(hasFocusableChild);
    }
  }, [id]);
  const getShouldKeepMenuOpenOnBlur = useCallback(() => {
    const toReturn = keepMenuOpenOnBlur;
    setKeepMenuOpenOnBlur(false);
    return toReturn;
  }, [keepMenuOpenOnBlur]);
  return {
    onKeyDown,
    getShouldKeepMenuOpenOnBlur
  };
});
//# sourceMappingURL=useFooterEvents.js.map